import { parseHash } from "~/stores/BuildPageStore";
import { useLocation } from "react-router-dom";

/**
 * Hook for getting the current job logs line number from the URL hash.
 */
export function useLineNumber() {
  const { hash, search } = useLocation();
  const jid = new URLSearchParams(search).get("jid");
  const { line, group } = parseHash(hash, jid) || {};

  return {
    group: group ? parseInt(group, 10) : undefined,
    lineNumber: line ? parseInt(line, 10) : undefined,
  };
}
